

Vue.component('datepicker', {
  props: ['value'],
  template: '<div><input type="text" v-bind:value="value" v-on:change="$emit(\'input\', $event.target.value)" data-input /></div>',
  mounted: function () {
    var vm = this;
    $(this.$el).flatpickr({
      inline:false,
      enableTime: false,
      wrap:true,
      altInput: true,
      dateFormat: "m/d/Y",
      onClose : function(){
        //console.log('fp closed');
      },
      onValueUpdate : function(){
        //console.log('fp updated');
      },
      onChange : function(dateobj, datestr){

        //vm.$emit('input', datestr);
      }
    });
  },
  watch: {
    
// value: function (value) {
//       // update value
//       $(this.$el).val(value).trigger('change');
//     }

  },
  destroyed: function () {

  }
});
